import { GenericSuspense } from "@harea/component";
import { AppHeader } from "components/AppHeader";
import { useIsMobile } from "@harea/component";
import { useCallback, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import AdminLeftSideBar5 from "components/layout/AdminLeftSideBar5";

export function AppLayout() {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(!isMobile);

  const toggleSidebar = useCallback(() => {
    setOpen((openState) => !openState);
  }, []);

  const pageContent = useMemo(
    () => (
      <div className="flex-1 space-y-4 overflow-y-auto p-6">
        <GenericSuspense>
          <Outlet />
        </GenericSuspense>
      </div>
    ),
    [],
  );

  return (
    <div className="flex h-svh w-full overflow-hidden bg-slate-100">
      <AdminLeftSideBar5 open={open} onToggle={toggleSidebar} />

      <main className="relative flex h-full w-full flex-1 flex-col overflow-hidden bg-background">
        <AppHeader onToggleSidebar={toggleSidebar} />

        {pageContent}
      </main>
    </div>
  );
}